import React , { Component } from 'react';
import InputText from '../components/formulario/InputText';
import InputFile from '../components/formulario/InputFile';
import Radio from '../components/formulario/Radio';
import { CONSTANTES } from '../utils/Constantes';
import Select from '../components/formulario/Select';
import Boton from '../components/formulario/Boton';
import Utils from '../utils/Validate';
import CalendarioRango from '../components/formulario/CalendarioRango';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button';
import Popover from 'react-bootstrap/Popover';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Modal from 'react-responsive-modal';
import { obtenerRemesas } from '../../service/actions';
import $ from 'jquery';
import ReactTable from 'react-table';
import {ReactTableDefaults} from 'react-table';
import 'react-table/react-table.css'
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';
import moment from 'moment';
import { Auth, Storage } from 'aws-amplify';
import ModalGenerico from '../components/comunes/ModalGenerico';
import Footer from '../components/comunes/Footer';
import Breadcrumb from '../components/comunes/Breadcrumb';
import { CSVLink } from "react-csv";
import Excel from '../resource/xls/Utils'
//const ExcelJS = require('exceljs');
class ProcesoMasivoUsuarios extends Component {
    state = {
       
        mostrarModal    : false,
        isLoading       : false, 
        open: false,
        disableDiv: false,
        //Agregando Nuevo
        file: '',
        fileUrl: '',	

        v_fileUrl: true,
          
        actUploadUrl: '',
        actDownloadUrl: ''
    }

    disableDiv = () => {
        this.setState({
           disableDiv:true
        });
    }

    enableDiv = () => {
        this.setState({
           disableDiv:false
        });
    }

    previousPageHandler = () => {
        this.setLocalStorage("FLUJO","1");
        this.props.props.history.push({ pathname : CONSTANTES.RUTA.detalle });
    }

    onCloseModal = ()  => {
        this.setState({ open: false});
    };

    setLocalStorage = (key, value) => {
        localStorage.setItem(key, JSON.stringify(value));
      }
    
    

    async componentWillMount() {
        await this.generarCabecerasCSV();
    }

    async componentDidMount(){
		if("true" !== localStorage.getItem('login')){
            await Auth.signOut();
        }
    }

    timer = () => {
        Auth.currentSession().then(response =>{
            var exp = moment.unix(response.accessToken.payload.exp).format('DD/MM/YYYY hh:mm:ss');
            var fecha_actual = moment(new Date()).format('DD/MM/YYYY hh:mm:ss');
            if(fecha_actual > exp){
                this.cerrarSesion();
            }
		})
		.catch(error =>{
			this.props.props.history.push({ pathname : CONSTANTES.RUTA.login }); 
		});
    }
    limpiarFormulario = () =>{
        this.setState({fileUrl: '',
                        file: ''
                    });
    }
    validarFormulario = (e) => {
        let response = true;
        if (this.state.fileUrl == '' || !this.state.v_fileUrl){
            this.setState({v_fileUrl:false});
            response = false;
        }else{
            this.setState({v_fileUrl:true})
        }                
        return response;
    }
    validarCampo = (e) => {
        let { value , name , files } = e.target;
        this.setState({['v_' + name] : Utils.validarCampo(name, value, files[0])}, () => {
            console.log(this.state.v_nombres);
        })   
    }
    onChange = (e) => {
        let { name, value, files } = e.target;
        if(name ==='fileUrl'){
            this.setState({ 
              file : files[0] ,
              fileUrl : value 
            }, () => { });
        }else{
            this.setState({ [name] : value }, () => {
            });
        }       
    }

    onDisabled = (e) =>{
        let { name, value } = e;
        this.setState({['d_' + name] : value , [name] : ''}, () => {

        });
    }
    consultarAtributosService = (params) => {
        this.props.mostrarLoading();
        return new Promise((resolve, reject)=>{
            this.props.props.callServiceUsuarios("GET","atributos", {...params}).then(response => {
                // console.log(response);
                if(response){
                    console.log(response);
                    if(200 === response.statusCode && 0 === response.body.responseCode){
                        let atributos = [];
                        atributos = response.body.data.attributes;
                        resolve(atributos)
                    }else{
                        this.props.mostrarModal("mensajeUsuario", null, response.body.responseMessage);
                    }
                    this.props.ocultarLoading();
                }
            }).catch( error => {
                console.error(error);
                this.props.ocultarLoading();
                this.props.mostrarModal("mensajeUsuario", null, "problemas al cargar atributos");
                reject(error);
            });
        });
    }
    generarCabecerasCSV = async () =>{
        let listaAtributos = await this.consultarAtributosService({});
        listaAtributos = listaAtributos.map(e=>({label: e.key, key: e.key}));
        let listaCabeceras = [{label: "cod_operacion", key: "cod_operacion"},
        {label: "perfil", key: "perfil"},
        {label: "username", key: "username"},
        {label: "nombres", key: "nombres"},
        {label: "apellidos", key: "apellidos"},
        {label: "correo", key: "correo"}];
        this.setState({headers: listaCabeceras.concat(listaAtributos)});
    }
    /** OBTENER REMESAS */    
    crearUsuario = async () => {
        try{
            this.props.mostrarLoading();
            /********obtener url importar exportar */
            let respArrayURL = await this.obtenerURL();
            let objURLImportar = respArrayURL[0];
            let objURLExportar = respArrayURL[1];
            /**********subir archivo to s3********** */
            await this.subirArchivoS3(this.state.file, objURLImportar.uploadUrl);
            /************iniciar Proceso Masivo*********** */
            let res= await this.iniciarProcesoMasivo(objURLImportar.downloadUrl, objURLExportar.uploadUrl, objURLExportar.downloadUrl);
            /*****************descargar respuesta********** */
            this.props.ocultarLoading();
            this.setState({open: false});
            await this.descargarArchivoS3(objURLExportar.downloadUrl);
            this.props.mostrarModal('mensaje', null, 'Finalizó el proceso de carga masiva. Se descargó el resultado.');
            this.limpiarFormulario();
        }catch(e){
            console.error(e);
            this.props.ocultarLoading();
            this.setState({open: false});
            if(!e.response)
                this.props.mostrarModal("mensajeUsuario", null, "Hemos tenido problemas con nuestro sistema.");
            else
                this.limpiarFormulario();
        }
    }    

    cerrarSesion = () => {
        this.props.mostrarLoading();      
        new Promise((resolve, reject) => {
          setTimeout(function(){
			//localStorage.clear();
			
            resolve(true);
          },500)
        }).then(() => {
          this.props.ocultarLoading();
          this.props.props.history.push({ pathname : CONSTANTES.RUTA.login });
        })
      }
    
    crear = () => {
        if(this.validarFormulario())       
            this.setState({ open: true});
    }
    /***********obtener URLS************/
    obtenerURLService= (params) => {               
        return new Promise((resolve, reject)=>{
                            this.props.props.callServiceUsuarios("GET","archivos/url", {...params})
                            .then(response => {                
                                if(response){
                                    console.log(response);
                                    if(200 === response.statusCode && 0 === response.body.responseCode){                        
                                        resolve(response.body.data);
                                    }else{
                                        reject(response.body.responseCode);
                                    }                
                                }
                            })
                            .catch(err=>reject(err));
                });        
    }
    obtenerURL = async () => {
        var hash = "_"+ new Date().getTime();
        let filename = this.state.file.name;
        let regExp = /\.[0-9a-z]+$/;
        let index = filename.search(regExp);
        let fileNameHash = filename.substring(0,index) + hash + filename.substring(index,filename.length);        

        let requestImportar = {
            extension: 'csv',
            fileName: fileNameHash,
            folderIdx: 0
        };
        let requestExportar = {
            extension: 'csv',
            fileName: fileNameHash,
            folderIdx: 1
        };
        return Promise.all([
            this.obtenerURLService(requestImportar),
            this.obtenerURLService(requestExportar)
        ] );        
    } 

    subirArchivoS3 = async (file, uploadUrl) =>{
        let csv = await Utils.readFile(file);
        return fetch(uploadUrl, {method: 'PUT', body: csv});
    }
    
    iniciarProcesoMasivo = async (importedFileDownloadUrl, exportedFileUploadUrl, exportedFileDownloadUrl) => {
        let request = {
            payload: {importedFileDownloadUrl, exportedFileUploadUrl, exportedFileDownloadUrl}
            };               
        return new Promise((resolve, reject)=>{
                            this.props.props.callServiceUsuarios("POST","usuarios/masivo", request)
                            .then(response => {                
                                if(response){
                                    console.log(response);
                                    if(200 === response.statusCode && 0 === response.body.responseCode){                        
                                        resolve(response.body.responseMessage);
                                    }else{
                                        reject(response.body.responseMessage);
                                    }                
                                }
                            })
                            .catch(err=>{
                                if(err.response && err.response.status == 504)
                                    this.props.mostrarModal("mensaje", null, "El proceso tomará unos minutos. Se le enviará por correo el resultado del proceso.");                                
                                reject(err);
                            });
                });        
    }

    descargarArchivoS3 = async (downloadUrl) => {                     
        return new Promise((resolve, reject)=>{
                    fetch(downloadUrl)
                    .then(response => {
                        if (response.status === 200){
                            response.blob().then(responseBlob => {                                
                                let url = window.URL.createObjectURL(responseBlob);
                                let a = document.createElement('a');
                                a.href = url;
                                a.download = `Informe_Operaciones_Masiva_${moment().format('YYYYMMDD')}.csv`;                                
                                a.click();
                                resolve("OK");
                            }).catch(e =>{
                                console.error(e);
                                reject(e);
                            });
                        }else if(response.status === 403){
                            reject('403');
                        }else{
                            reject('error');
                        }
                    }).catch(e =>{
                        console.error(e);
                        reject(e);
                    });
                });        
    } 

    render = ()=>{
        var { open } = this.state;
         
        return(
            <section className="showMntUsuarios container-fluid container-filtercolor">
                    <div className="container container-filter justify-content-start mb-flex-column">
                        <div className="container-filter-info justify-content-start mb-full">
                            <div className="">
                            <Breadcrumb  opciones={this.props.opciones} accionActual={this.props.accionActual} accionDefault={this.props.accionDefault} irDefault={this.props.irListarUsuario}/>
                                <h1><b>Carga masiva</b> de usuarios</h1>
                                <p>Aquí gestiona la creación y actualización de datos masiva de usuarios en el Portal.</p>                           
                            </div>                            
                        </div>                       
                                                
                    </div>
                    <div className="container-fluid d-flex mb-flex-column justify-content-between">
                        <div className={"container boxBuscar mb-w100 d-flex flex-justify-between w100"}>                           
                            <Col className="seccionFiltrar s12 m12 l12">
                                <Row>                                    
                                    <Col className="s12 m2 l1 font-footer" style={{float: "right", display: "flex", cursor: "pointer"}} onClick={this.props.irListarUsuario}>
                                        <div className="icon-regresar"/> Regresar
                                    </Col>
                                </Row>
                                {this.state.headers && <Row>
                                    <CSVLink  headers={this.state.headers} separator={','}   data={[]} filename={"Formato_Importacion_Masiva.csv"} enclosingCharacter={`"`} onClick={async (event, done) => {await Excel.generarExcel(); 
                                                                                                                                                                                                       }}>
                                        <Col className="s12 m2 l2 font-download" style={{float: "left", display: "flex", cursor: "pointer"}}>
                                            <div className="icon-download"/> DESCARGAR FORMATO
                                        </Col>
                                    </CSVLink>                                 
                                </Row>
                                }                              
                                <Row>
                                    <Col className="s12 m9 l9" >
                                        <InputFile
                                            name="fileUrl"
                                            alias="archivo"
                                            value={this.state.fileUrl}
                                            //onBlur={this.validarCampo} 
                                            onChange= {(e) => { 
                                                    this.onChange(e); 
                                                    this.validarCampo(e);
                                            }}
                                            placeholder="Archivo de Creacion Masiva"
                                            validate = {this.state.v_fileUrl}
                                            defaultUrl = "Ningún archivo seleccionado"
                                            textButton="IMPORTAR"
                                            clase = {"input-v2"}
                                            />
                                    </Col>                                     
                                    <Col className="s12 m3 l3" >
                                        <button 
                                        className={"botonFormulario right btn-small no-box-shadow"} 
                                        onClick={this.crear}
                                        style={{marginBottom: "10px"}}>
                                        CREAR USUARIOS
                                        </button>
                                    </Col>
                                </Row>                      
                            </Col>
                        </div>
                        <Modal open={open} onClose={this.onCloseModal} center classNames={{modal: 'modal-sm'}} >                            
                                <div className="header-modal-usuario">
                                    CREACIÓN Y ACTUALIZACIÓN MASIVA DE USUARIOS
                                </div>
                                <div className="body-modal-usuario">                                       
                                <Row  className="div-modal-det" style={{margin: "auto", float: "none"}}>    
                                    <Col  className="s12 m12 l12 div-subtitulo-modal" style={{float: "left"}}>
                                    ¿Estas seguro de realizar la creación y actualización de datos masiva de usuarios?
                                    </Col>                                   
                                </Row>
                                <Row>
                                    <Col className="s12 m6 l4" style={{margin: "auto", float: "left"}}>
                                            <button className={"botonFormulario right btn-small btn-g no-box-shadow"} onClick={this.onCloseModal}  style={{marginBottom: "10px"}}>CANCELAR</button>
                                    </Col>
                                    <Col className="s12 m6 l4" style={{margin: "auto", float: "right"}}>
                                            <button className={"botonFormulario right btn-small no-box-shadow"} onClick={this.crearUsuario} Style={{marginBottom: "10px"}}>CONFIRMAR</button>
                                    </Col>
                                </Row>
                                </div>
                        </Modal>
                                    
                    </div>   
            </section>                          
           
        );
    }
}
export default ProcesoMasivoUsuarios
//export default HOC(CrearUsuario);